/* eslint-disable no-param-reassign */
export default function ToText(node) {
  const tag = document.createElement("div");
  tag.innerHTML = node;
  node = tag.innerText;
  return node;
}